import React from 'react'

import API from 'common/src/api'

class IndustryEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSubcategories: [],
      unselectedSubcategories: []
    }
    this.getSubcategories = this.getSubcategories.bind(this)
    this.removeSubcategory = this.removeSubcategory.bind(this)
    this.addSubcategory = this.addSubcategory.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedSubcategories.length === 0 || this.props.handleUpdate === undefined) { return }
    this.props.handleUpdate()
  }

  componentDidMount() {
    this.getSubcategories()
  }

  getSubcategories() {
    $.ajax(API.V3.subCategoriesGet({ 'filter[category_id]': this.props.categoryID })).done((response) => {
      let subcategories = response.data.map(item => ({ id: parseInt(item.id, 10), name: item.attributes.name }))
      let subcategoryIds = this.props.subcategoryIds
      let selectedSubcategories = subcategoryIds ? subcategories.filter(sc => subcategoryIds.includes(sc.id)) : subcategories
      let unselectedSubcategories = subcategoryIds ? subcategories.filter(sc => !subcategoryIds.includes(sc.id)) : []

      this.setState({ selectedSubcategories: selectedSubcategories, unselectedSubcategories: unselectedSubcategories })
    });
  }

  addSubcategory(event) {
    let id = event.currentTarget.getAttribute("data-id")
    let selectedSubcategories = this.state.selectedSubcategories.slice()
    let unselectedSubcategories = this.state.unselectedSubcategories.slice()
    let index = unselectedSubcategories.findIndex(subcategory => subcategory.id == id)
    let subcategory = unselectedSubcategories.splice(index,1)[0]

    selectedSubcategories.push(subcategory)
    this.setState({ selectedSubcategories: selectedSubcategories, unselectedSubcategories: unselectedSubcategories })
  }

  removeSubcategory(event) {
    let id = event.currentTarget.getAttribute("data-id")
    let selectedSubcategories = this.state.selectedSubcategories.slice()
    let unselectedSubcategories = this.state.unselectedSubcategories.slice()
    let index = selectedSubcategories.findIndex(subcategory => subcategory.id == id)
    let subcategory = selectedSubcategories.splice(index,1)[0]

    unselectedSubcategories.push(subcategory)
    this.setState({ selectedSubcategories: selectedSubcategories, unselectedSubcategories: unselectedSubcategories })
  }

  render() {
    return (
      <div className="categories mt16 mb16">
        {
          !this.props.jobFilterLocked &&
          <span className="industry-close text-copy-0 ficon-delete pr16"
            onClick={this.props.removeCategory}
            data-id={this.props.categoryID}></span>
        }
        <div className="font-21 bold border-top pt8 mt32">
          {this.props.categoryName}
        </div>
        <input type="hidden"
          name={this.props.action === "update"
              ? "job_filter[job_filter_categories_attributes][][category_id]"
              : "provider_account[job_filter][job_filter_categories][][category_id]"
          }
          value={this.props.categoryID}
        />
        <h4 className='font-14 bold mt8 mb8'>You offer the following services:</h4>


        <div className='subcategories'>
          { this.state.selectedSubcategories.map((sc, i) => {
            return (
              <div className="inline-block" key={sc.id} data-id={sc.id} onClick={this.props.jobFilterLocked ? null : this.removeSubcategory}>
                <input type="hidden"
                  name={this.props.action === "update"
                      ? `job_filter[job_filter_sub_categories_attributes][][sub_category_id]`
                      : `provider_account[job_filter][job_filter_subcategories][][sub_category_id]`
                  }
                  value={sc.id}
                />
                <div className="hidden-xs">
                  <div className={`tag label ${this.props.jobFilterLocked ? 'bg-dark-gray text-copy-1' : 'label-primary'}`}>
                    { sc.name }
                    {
                      !this.props.jobFilterLocked &&
                      <span className="fs8 ficon-delete"></span>
                    }
                  </div>
                </div>
                <div className="visible-xs">
                  <div className={`tag label ${this.props.jobFilterLocked ? 'bg-dark-gray text-copy-1' : 'label-primary'}`}>
                    <div className="row">
                      <div className="col-xs-9 min-width-80">
                        { sc.name }
                      </div>
                      {
                        !this.props.jobFilterLocked &&
                        <div className="col-xs-3 pl0 text-right">
                          <span className="ficon-delete"></span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {this.state.unselectedSubcategories.length > 0 &&
          <div>
            <h4 className="font-14 pt16 bold">You do not offer:</h4>
            { this.state.unselectedSubcategories.map((sc, i) => {
              return (
                <div className={`tag label border text-copy-1 ${this.props.jobFilterLocked ? 'bg-dark-gray' : ''}`} key={sc.id} data-id={sc.id} onClick={this.props.jobFilterLocked ? null : this.addSubcategory}>
                  <div className="row visible-xs">
                    <div className="col-xs-9 pr8">
                      { sc.name }
                    </div>
                    {
                      !this.props.jobFilterLocked &&
                      <div className="col-xs-3 pl0 text-right">
                        +
                      </div>
                    }
                  </div>
                  <div className="hidden-xs">
                    { sc.name }
                    {
                      !this.props.jobFilterLocked &&
                      <span className="pl8">+</span>
                    }
                  </div>
                </div>
              )
            })}
          </div>
        }
      </div>
    )
  }
}

export default IndustryEditor
